import { testService, forgotPassword, getIMCDetails } from "../service";

export const createEmployees = (data) => {
    return testService(data);
};

export const forgotPasswordController = (data) => {
    return forgotPassword(data);
};

export const getIMCclientController = () => {
    return getIMCDetails();
};
